export const PaymentStatusType = {
    PAID: "Paid",
    PENDING: "Pending",
    CANCELED: "Canceled"
}